module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABNElEQVRYR+2WrVIEMRCEux8SDAjOgAEBBgwnwIABAQYMCM7AQ/bVViXUVMjv1laC2JWbycw3nclMiMEfB8fHCrAqUFRA0gHJnznFWrM3CzA5APAN4JjkrgVC0hGALwCHuQSSACa4j7sh+VkDIekEwIexTUKUFPBZeF9nJN9zEJJOAbwZm6x6NTUQZnNB8jUGIekcwItZK6pWBJicRbK6IvlsISRdAngy/4pqTbZVAA4izO6G5KNbuwbwYIInVQqVqwZwgcIst87hnXH8R51czTQBJLK1/n9VqbktTUcQnPctAJv1tLwleV8b2Ns1K+BUGAcgKSy4fkcQuWr9ijDSZPpdw6GNKDJY+rViM1L7D6P/Mo7HPUi85jXPqlT3q9k7qxO2tttFh9GSwWcPoyUh1iMYrsAeHsKoITGF06EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.png
// module id = /TeD
// module chunks = 6